import { useSpring } from '@react-spring/web';
import React, { useCallback, useState } from 'react';
import { createContainer } from 'react-tracked';
import Endorsment from '../components/Pod/Endorsment';
import Submit from '../components/Pod/Submit';
import UserPod from '../components/Pod/UserPod';

const usePodHelper = () => {
  const [state, setState] = useState();
  const STEPS = [<UserPod />, <Endorsment />, <Submit />];
  const [currentStep, setCurrentStep] = useState(0);

  const springProps = useSpring({
    from: { transform: 'translateX(40%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
    config: { tension: 100, friction: 30 },
    width: '100%',
    height: '100%',
  });

  function incrementStep() {
    if (STEPS.length == currentStep) return;
    setCurrentStep(currentStep + 1);
  }

  function decrementStep() {
    if (currentStep == 0) return;
    setCurrentStep(currentStep - 1);
  }

  function backToHome() {
    setCurrentStep(0);
  }

  const requestConnection = useCallback(() => {
    if (currentStep == 1) return;
    setCurrentStep(1);
  }, [currentStep]);

  const addPeer = useCallback(() => {
    setCurrentStep(2);
  }, []);

  const handleSubmitCode = useCallback(() => {
    setCurrentStep(0);
  }, []);

  return [{ requestConnection, handleSubmitCode, backToHome, STEPS, currentStep, addPeer, springProps }, setState];
};

const { Provider, useTracked } = createContainer(() => usePodHelper());

export const usePodState = useTracked;
export const PodStateProvider = ({ children }) => <Provider>{children}</Provider>;
export default PodStateProvider;
